<template>
  <div class="editApp">
    <Modal
      title="驳回原因"
      v-model="modalView"
      @on-visible-change="changeVisible"
      :mask-closable="false"
      width="750"
      class="editApp-modal"
    >
      <div class="editApp-item">
        <p>驳回原因：</p>
        <p class="lineBreak">{{form.rejectCause||"暂无"}}</p>
      </div>
      <div class="editApp-item">
        <p>审批人：</p>
        <p>{{form.auditor||"暂无"}}</p>
      </div>
      <div class="editApp-item">
        <p>驳回时间：</p>
        <p>{{form.auditTime||"暂无"}}</p>
      </div>

      <div slot="footer">
        <Button
          class="btn104"
          type="primary"
          :loading="loading"
          shape="circle"
          @click="modalView = false"
          >关闭</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { putApp } from "@/api/app";

export default {
  name: "",
  components: {},
  props: {
    form: Object,
  },
  data() {
    return {
      loading: false,
      modalView: false,
      ruleCustom: {
        name: [
          {
            required: true,
            validator: _FORM.validate_len,
            max_len: 16,
            trigger: "blur",
            label: "应用名称",
          },
        ],
        appDescribe: [
          {
            required: true,
            validator: _FORM.validate_len,
            max_len: 500,
            trigger: "blur",
            label: "应用描述",
          },
        ],
      },
    };
  },
  created() {
    this.modalView = true;
  },
  methods: {
    confirm() {
      this.modalView = false;
    },
    cancle() {
      this.modalView = false;
    },
    changeVisible(val) {
      this.modalView = false;
      if (!val) {
        this.$emit("close");
      }
    },
  },
};
</script>

<style lang="scss">
.editApp {
  &-item {
    display: flex;
    margin: 10px 0;
    flex-wrap: wrap;
    > p:nth-of-type(1) {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #67799c;
      width: 80px;
      text-align: right;
    }
    > p:nth-of-type(2) {
      flex:1;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #2f4061;
    }
  }
}
</style>
